
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from './Components/Header/Header';
import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Footer from './Components/FooterSection/Footer';
import Home from './Components/HomeSection/Home';
import Courses from './Components/Courses/Courses';
import About from './Components/AboutSection/About';
import Contact from './Components/Contact/Contact';
import Page from './Components/PageNot/Page';

function App() {
  return (
    <div >
      <Router>
        <Header></Header>
        <Switch>
          <Route path="/home">
            <Home></Home>
          </Route>
          <Route path="/courses">
            <Courses></Courses>
          </Route>
          <Route path="/about">
            <About></About>
          </Route>
          <Route path="/contact">
            <Contact></Contact>
          </Route>
          <Route exact path="/">
            <Home></Home>
          </Route>
          <Route path="*">
            <Page></Page>
          </Route>

        </Switch>
        <Footer></Footer>
      </Router>

    </div>
  );
}

export default App;
